// extracted by mini-css-extract-plugin
export default {"bimWorkOrderPrice":"BimWorkOrderPriceTable_bimWorkOrderPrice__-ptNU","ag-center-cols-container":"BimWorkOrderPriceTable_ag-center-cols-container__cRrc8"};